import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { brands } from '../mock';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { ArrowRight, ExternalLink } from 'lucide-react';

const Brands = () => {
  const { language, t } = useLanguage();

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-[#021F3F] via-[#0A3D62] to-[#021F3F]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            {t.brands.title}
          </h1>
          <p className="text-xl text-gray-300 mb-8">
            {t.brands.subtitle}
          </p>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto" />
        </div>
      </section>

      {/* Brands Grid */}
      <section className="py-20 bg-[#F8F8F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {brands.map((brand, index) => (
              <Card
                key={brand.id}
                className="group overflow-hidden border-none shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
              >
                {/* Brand Logo Card */}
                <div className="relative h-80 overflow-hidden bg-white flex flex-col items-center justify-center p-8">
                  {/* Brand Number Badge */}
                  <div className="absolute top-4 right-4 w-12 h-12 rounded-full bg-[#D4AF37] flex items-center justify-center shadow-lg z-10">
                    <span className="text-[#021F3F] text-xl font-bold">{index + 1}</span>
                  </div>
                  
                  {/* Logo Container */}
                  <div className="w-56 h-56 flex items-center justify-center transform group-hover:scale-105 transition-transform duration-500">
                    {/* Logo Image - scaled to 95% */}
                    <img
                      src={brand.logo}
                      alt={brand.name}
                      className="max-w-full max-h-full object-contain"
                      style={{ transform: 'scale(0.95)' }}
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 bg-white">
                  <p className="text-sm text-gray-500 leading-relaxed mb-4">
                    {brand.description[language]}
                  </p>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    {brand.detailedDescription[language]}
                  </p>
                  
                  <a href={brand.link} target="_blank" rel="noopener noreferrer">
                    <Button
                      className="w-full bg-[#0A3D62] hover:bg-[#021F3F] text-white transition-all duration-300 group"
                    >
                      {t.brands.viewProject}
                      <ExternalLink className="ml-2 group-hover:translate-x-1 transition-transform" size={16} />
                    </Button>
                  </a>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-gradient-to-br from-[#021F3F] to-[#0A3D62] rounded-2xl p-12 shadow-2xl">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              {language === 'ro' ? 'Vrei să colaborezi cu noi?' : 'Want to collaborate with us?'}
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              {language === 'ro'
                ? 'Hai să discutăm despre următorul tău proiect.'
                : "Let's talk about your next project."}
            </p>
            <a href="/contact">
              <Button
                size="lg"
                className="bg-[#D4AF37] hover:bg-[#E6C76D] text-[#021F3F] font-semibold px-8 py-6 text-lg rounded-lg transform hover:scale-105 transition-all duration-300 shadow-xl"
              >
                {t.home.ctaButton}
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Brands;